import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2 }, /* @__PURE__ */ React.createElement("path", { d: "M22 11.086v.92a10 10 0 1 1-5.93-9.14" }), /* @__PURE__ */ React.createElement("path", { d: "m22 4.006-10 10.01-3-3" })));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
